import React, {useEffect, useMemo, useRef, useState} from 'react';
import WheelPicker from "../wheelPicker/WheelPicker";
import Moment from 'moment-jalaali';
// import { months } from '../../utils/variables';
import Modal from './Modal';
import ScrollerPicker from './ScrollerPicker';

let [full_days, full_months] = [[], []];

for (let i = 1; i <= 31; i++) {
    if (i <= 12) full_months.push(`${i<10?'0':''}${i}`);
    full_days.push(`${i<10?'0':''}${i}`)
}

export default function DatePicker({col = 6, label, value, isBirthDate = false, onChange, required, disabled, isLicenseDate = false,isInsuranceDate = false}) {

    const datePicker = useRef(null)
    const selectedBorder = useRef(null)

    const [showPicker, setShowPicker] = useState(false);
    const [date, setDate] = useState({
        day: '01',
        month: '01',
        year: isBirthDate ? Moment().jYear() -10: Moment().jYear(),
    });
    const leapYear = [1,5,9,13,17,22,26,30]
    const [dateStep,setDateStep] = useState('year');
    const days =useMemo( ()=>{
        const copyDays = []
        if(!isInsuranceDate && parseInt(date.year) === Moment().jYear() && parseInt(date.month) === Moment().jMonth()+1){ 
            // let copyDays = new Array(Moment().jDate())
            for (let i = 1; i <= Moment().jDate(); i++) {
                copyDays.push(`${i<10?'0':''}${i}`)
            }
            setDate({
                ...date,
                day: '01',
            })
            return copyDays
        }
        if(parseInt(date.month) > 6) {
            // if( leapYear.includes(date.year %33) && date.month === 12){
            //     let copyDays = new Array(30)
            //     for (let i = 1; i <= 30; i++) {
            //         copyDays.push(`${i}`)
            //     }
            //     return copyDays
            // }else 
            if(!leapYear.includes(date.year %33) && parseInt(date.month) === 12){
                // let copyDays = new Array(29)
                for (let i = 1; i <= 29; i++) {
                    copyDays.push(`${i<10?'0':''}${i}`)
                }
                return copyDays
            }else{
                // let copyDays = new Array(30)
                for (let i = 1; i <= 30; i++) {
                    copyDays.push(`${i<10?'0':''}${i}`)
                }
                return copyDays
            }
        }else {
            // let copyDays = new Array(31)
            for (let i = 1; i <= 31; i++) {
                copyDays.push(`${i<10?'0':''}${i}`)
            }
            return copyDays
        }
    },[date.month,date.year,isInsuranceDate])

    const years = useMemo(() => {
        const years = [];
        const config = {
            // originDate: isBirthDate ? 1300 : Moment().jYear(),
            // from: isBirthDate ? 0 : isLicenseDate ? -50 : -10,
            // to: isBirthDate ? 100 : isLicenseDate ? 0 : 10,
            originDate:  Moment().jYear(),
            from: isBirthDate ? -100 : isLicenseDate ? -50 : -10,
            to: !isInsuranceDate ? 0 : 10,
            // to: isBirthDate ? 0 : isLicenseDate ? 0 : 10,
        };
        for (let i = config.from; i <= config.to; i++) {
            years.push(`${config.originDate + i}`);
        }
        return years;
    }, [isBirthDate,isLicenseDate]);
    const months = useMemo(()=>{
        const months = []
        if(!isInsuranceDate && parseInt(date.year) === Moment().jYear()){ 
            for (let i = 1; i <= Moment().jMonth()+1; i++) {
                if (i <= 12) months.push(`${i<10?'0':''}${i}`);
            }
            setDate({
                ...date,
                day: '01',
                month: '01',
            })
            return months
        } else{
            return full_months
        }
    }, [date.year,isInsuranceDate])
    // const days = useMemo(()=>{
    //     const days = []
    //     if(!isInsuranceDate && parseInt(date.year) === Moment().jYear() && parseInt(date.month) === Moment().jMonth()+1){ 
    //         for (let i = 1; i <= Moment().jDate(); i++) {
    //             days.push(`${i<10?'0':''}${i}`)
    //         }
    //         setDate({
    //             ...date,
    //             day: '01',
    //         })
    //         return days
    //     } else{
    //         return full_days
    //     }
    // }, [date.month,date.year,isInsuranceDate])
    const dataProps = useMemo(() => JSON.stringify({value, required, label}), [label, required, value]);

    useEffect(() => {
        const [year, month, day] = (value || `${isBirthDate ? Moment().jYear() -10:Moment().jYear()}/01/01`).split('/');
        setDate({
            day,
            month,
            year,
        });
        // document.addEventListener('mousedown',(e)=>{
        //     datePicker.current && !datePicker.current.contains(e.target) && setShowPicker(false)
        // })
        // return()=>{
        //     document.removeEventListener('mousedown',(e)=>{
        //         datePicker.current && !datePicker.current.contains(e.target) && setShowPicker(false)
        //     });
        // }
    }, [value]);

    function submitDate() {
        onChange(`${date.year}/${date.month}/${date.day}`);
        setShowPicker(false);
        // setDateStep('year')
    }

    function changeDate(name, value) {
        setDate(prevState => ({
            ...prevState,
            [name]: value,
        }));
        // if( name === 'year') {
        //     setDateStep('month')
        // }else if( name === 'month') {
        //     setDateStep('day')
        // }
    }
    function handleMonthChange(value, action) {
        const index = months.findIndex(month=> month.label === value);
        action === 'next'?
            changeDate('month' ,(index === 11 ? months[index].value : months[index+1].value)) :
            changeDate('month' ,(index === 0 ? months[index].value : months[index-1].value))

    }
    function monthConvert(value){
        return months[value-1].label
    }


    // const scrollColumnRef = useRef(null);
    // const dateInput = useRef(null)

//   const handleScroll = () => {
//     const items = scrollColumnRef.current.children;
//     const columnHeight = scrollColumnRef.current.clientHeight;
//     const centerPoint = scrollColumnRef.current.scrollTop + columnHeight / 2;
//     const dateItem = document.getElementById("date-item")
//     Array.from(items).forEach((item,i) => {
//       const itemRect = item.getBoundingClientRect();
//       const columnRect = scrollColumnRef.current.getBoundingClientRect();
//       const inputDate = dateInput.current.getBoundingClientRect()
//     //   console.log(inputDate.top,inputDate.bottom)
//     //   console.log(itemRect.top,itemRect.bottom)
//       if (itemRect.top > inputDate.top && itemRect.bottom < inputDate.bottom){
//             // console.log(item.getAttribute('content'))
//             console.log(dateItem.clientHeight)
//             // console.log(inputDate.top,inputDate.bottom)
//             // console.log(itemRect.top,itemRect.bottom)
//             // console.log(scrollColumnRef.current.scrollTop + (itemRect.top - inputDate.top) )
//             // scrollColumnRef.current.scrollTo({
//             //     // top: scrollColumnRef.current.scrollTop + itemRect.top - inputDate.top - 10,
//             //     top: scrollColumnRef.current.scrollTop + dateItem.clientHeight/2,
//             //     behavior: 'smooth'
//             //     });
//         }
//     //   const itemCenterY = itemRect.top - columnRect.top + itemRect.height / 2;

//     //   // Calculate the threshold for 80%
//     //   const itemThreshold = itemRect.height * 0.8;

//     //   // Check if 80% of the item has passed the center point
//     //   if (itemCenterY < centerPoint - (itemThreshold / 2) && itemCenterY > centerPoint - itemThreshold) {
//     //     const offset = (columnHeight / 2) - (itemRect.height / 2);
//     //     scrollColumnRef.current.scrollTo({
//     //       top: item.offsetTop - offset,
//     //       behavior: 'smooth'
//     //     });
//     //   }
//     });
//   };

//   useEffect(() => {
//     const scrollColumn = scrollColumnRef.current;
//     // showPicker && console.log(dateInput.current)
//     // showPicker && console.log(scrollColumn.current.children)
//     showPicker && scrollColumn.addEventListener('scroll', handleScroll);
//     // handleScroll()
//     return () => {
//       showPicker && scrollColumn.removeEventListener('scroll', handleScroll);
//     };
//   },[]);
    // const offsetTop = scrollColumnRef.current.children[1].getBoundingClientRect().top
    // useEffect(()=>{
    //     function handling() {
    //         const selected = document.getElementsByClassName("selected")[0]
    //         console.log(scrollColumnRef.current.children[1].getBoundingClientRect().top)
    //         const offset = selected.getBoundingClientRect().top - 340
    //         scrollColumnRef.current.scrollTo({
    //             top: scrollColumnRef.current.scrollTop + offset  ,
    //             behavior: 'smooth'
    //         });
    //     }
    //     showPicker && handling()
    // },[date])
    return (
        <>
        {/* version1 */}
              {
                showPicker &&
                <div className='date-picker'>
                    <div className='picker-box'>
                        <div className='d-flex flex-row-reverse'>
                            <div className='wheel-box'>
                                <p className='text-center mb10'>روز</p>
                                <WheelPicker
                                    value={date.day}
                                    onChange={(value) => changeDate('day', value)}
                                >
                                    {
                                        days.map(day => (
                                            <div className='wheel-item' content={day} key={day}>{day}</div>
                                        ))
                                    }
                                </WheelPicker>
                            </div>
                            <div className='wheel-box mr40 ml40'>
                                <p className='text-center mb10'>ماه</p>
                                <WheelPicker
                                    value={date.month}
                                    onChange={(value) => changeDate('month', value)}
                                >
                                    {
                                        months.map(month => (
                                            <div className='wheel-item' content={month} key={month}>{month}</div>
                                        ))
                                    }
                                </WheelPicker>
                            </div>
                            <div className='wheel-box'>
                                <p className='text-center mb10'>سال</p>
                                <WheelPicker
                                    value={date.year}
                                    onChange={(value) => changeDate('year', value)}
                                >
                                    {
                                        years.map(year => (
                                            <div className='wheel-item' content={year} key={year}>{year}</div>
                                        ))
                                    }
                                </WheelPicker>
                            </div>
                        </div>
                        <button
                            onClick={submitDate}
                            className='btn btn-white-purple btn-block btn-circle mt10'
                        >
                            تایید
                        </button>
                    </div>
                </div>
            }   
            {/* version2 */}
            {/* {showPicker &&( */}
                 {/* <Modal visible={showPicker}>
                <div className='date-modal' ref={datePicker}>
                    <div className='date-header'>
                        <button className={`btn header-items ${monthConvert(date.month) === 'فروردین' ? 'disable' : ''}`} onClick={()=>handleMonthChange(monthConvert(date.month) , 'prev')}>
                            <i className='fas fa-arrow-left '/>
                        </button>
                        <div className='header-items' onClick={()=>  setDateStep('year')}><i className={`fas fa-caret-down`}/>{date.year}</div>
                        <div className='header-items' onClick={()=>  setDateStep('month')}><i className={`fas fa-caret-down`}/>{monthConvert(date.month)}</div>
                        <button className={`btn header-items ${monthConvert(date.month) === 'اسفند' ? 'disable' : ''}`} onClick={()=>handleMonthChange(monthConvert(date.month) , 'next')}>
                            <i className='fas fa-arrow-right '/>
                        </button>
                    </div>
                    <div className='date-body'>
                    {dateStep === 'year' &&(
                        <div className='date-modal-picker'>
                            {years.map((year)=>(
                                <li className={`year-modal ${date.year === year ? 'selected' : ''}`} key={year} onClick={()=>changeDate('year', year)}>
                                    {year}
                                </li>
                            ))}
                        </div>
                    )}
                    {dateStep === 'month' &&(
                        <div className='date-modal-picker'>
                            {months.map((month)=>(
                                <li className={`month-modal ${monthConvert(date.month) === month.label ? 'selected': ''}`} key={month.value} onClick={()=>changeDate('month', month.value)}>
                                    {month.label}
                                </li>
                            ))}
                        </div>
                    )}
                    {dateStep === 'day' && (
                        <div className='date-modal-picker'>
                            {days.map((day)=>(
                                <li className={`day-modal ${date.day === day ? 'selected' : ''}`} key={day} onClick={()=>changeDate('day', day)}>
                                    {day}
                                </li>
                            ))}
                        </div>
                    )}
                    </div>
                    <div className='close-modal'>
                        <button
                            onClick={submitDate}
                            className='btn btn-green btn-block btn-circle mt10'
                        >
                            تایید
                        </button>
                    </div>
                </div>
                </Modal> */}
            {/* )} */}
            {/* version3 */}
            {
                // <Modal visible={showPicker} >
                //     <div className='date-modal' ref={datePicker}>
                //     <div className='date-box'>
                //         <div className='selected-border'ref={selectedBorder}></div>
                //         <div className='date-col'>
                //             <label>سال</label>
                //             <ScrollerPicker data={years} label='year' value={date.year} changeDate={changeDate}/>
                //         </div>
                //         <div className='date-col'>
                //             <label>ماه</label>
                //             <ScrollerPicker data={months} value={parseInt(date.month)} hasLabel={true} label="month" changeDate={changeDate}/>
                //         </div>
                //         <div className='date-col'>
                //             <label>روز</label>
                //             <ScrollerPicker data={days} value={date.day} label='day' changeDate={changeDate}/>
                //         </div>
                //     </div>
                    
                //         <button
                //             onClick={submitDate}
                //             className='btn btn-white-purple w-50 btn-circle m10'
                //         >
                //             تایید
                //         </button>
                   
                // </div>
                
                //   </Modal>
                }
            <div className={`col-${col}`} data-props={dataProps}>
                {
                    label &&
                    <div className='mt10 mb5'>
                        {
                            required &&
                            <span className='required-icon'>* </span>
                        }
                        <label>{label}</label>
                    </div>
                }
                <div className='input-parent rtl'>
                    <button
                        className={`picker ${disabled ? 'disabled': ''}`}
                        onClick={() => disabled ? setShowPicker(false) : setShowPicker(true)}>
                        {
                            value || '--/--/----'
                        }
                    </button>
                </div>
            </div>
        </>
    );
}
